// extracted by mini-css-extract-plugin
module.exports = {"root":"InstructionsSectionsList_root__3uN2I","grid":"InstructionsSectionsList_grid__2EQiP"};